module.exports = __webpack_public_path__ + "img/success.565b56a1.png";